const AlertIcon = (props) => {
  return (
    <svg fill="currentColor" aria-hidden="true" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 10.25C12.4142 10.25 12.75 10.5858 12.75 11V13.5C12.75 13.9142 12.4142 14.25 12 14.25C11.5857 14.25 11.25 13.9142 11.25 13.5V11C11.25 10.5858 11.5857 10.25 12 10.25ZM18.0729 18.5L12 6.3541L5.92701 18.5H18.0729ZM18.4343 19.2228L18.4347 19.2236ZM18.8819 20H5.11799C4.37461 20 3.89111 19.2177 4.22356 18.5528L11.1055 4.78885C11.4741 4.05181 12.5259 4.05181 12.8944 4.78886L19.7763 18.5528C20.1088 19.2177 19.6253 20 18.8819 20Z"
        stroke="none"
      />
      <circle cx="12" cy="16.25" r="0.75" />
    </svg>
  );
};

export { AlertIcon };
